module.exports = __webpack_public_path__ + "img/checkout.7c7233f8.png";